import React, { useEffect } from 'react'
import NavHeader from '../Components/NavHeader'
import Inicio from '../Components/Home/Inicio'
import Nosotros from '../Components/Home/Nosotros'
import Slider from '../Components/Home/Slider'
import Servicios from '../Components/Home/Servicios'
import InicioPorafolio from '../Components/Home/InicioPorafolio'
import Contacto from '../Components/Home/Contacto'
import Footer from '../Components/Footer'


const setMeta = (name, content, attr = 'name') => {
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
};

const setCanonical = (href) => {
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', 'canonical');
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
};

const Home = () => {
    useEffect(() => {
        document.title = 'Dscode | Desarrollo de Landing Pages, Ecommerce y Sistemas a medida en Paraguay';
        setMeta(
            'description',
            'Dscode desarrolla landing pages, tiendas online (ecommerce) y sistemas empresariales a medida en Paraguay. Soluciones digitales con diseño moderno, SEO y rendimiento optimizado.'
        );
        setCanonical('https://dscode.com.py/');
    }, []);

    return (
        <div>
            <NavHeader />
            <Inicio />
            <Nosotros />
            <Slider />
            <Servicios />
            <InicioPorafolio />
            <Contacto />
            <Footer />
        </div>
    )
}

export default Home
